import { Module } from 'vuex';
import { IRelyingPartyConsent } from '@/shared/model/consent-relying-party.model';
import axios from 'axios';
import { RootState } from '@/shared/config/config';

export enum ConsentInvoker {
  TAU,
  REDIRECT_SERVLET
}

interface ConsentStoreState {
  consentInvoker: ConsentInvoker;
  relyingPartyConsent: IRelyingPartyConsent[];
}

export const consentStore: Module<ConsentStoreState, RootState> = {
  state: {
    consentInvoker: null,
    relyingPartyConsent: []
  },

  getters: {
    getRelyingPartyConsentByClientId: (state, getters, rootState) => (client_id: string) => {
      return state.relyingPartyConsent.find(relyingParty => relyingParty.client_id === client_id);
    },

    getConsentInvoker: (state, getters, rootState) => () => {
      return state.consentInvoker;
    }
  },

  mutations: {
    addRelingPartyConsentInfo(state, profile) {
      const consent: IRelyingPartyConsent = {
        client_id: profile.name,
        consent_required: profile.consent_req,
        accepted: false,
        rejected: false
      };

      const storedConsent = state.relyingPartyConsent.find(relyingParty => relyingParty.client_id === profile.name);
      if (!storedConsent) {
        state.relyingPartyConsent.push(consent);
      }
    },

    acceptRelyingPartyConsent(state, client_id) {
      axios
        .post('api/delegate/cocos/relying-party', { clientId: client_id })
        .then(response => {
          const storedConsent = state.relyingPartyConsent.find(relyingParty => relyingParty.client_id === client_id);
          storedConsent.accepted = true;
          storedConsent.rejected = false;
        })
        .catch(() => {
          console.log('Consent saving failed.');
        });
    },

    acceptConsent(state, client_id) {
      const storedConsent = state.relyingPartyConsent.find(relyingParty => relyingParty.client_id === client_id);
      storedConsent.accepted = true;
      storedConsent.rejected = false;
    },

    rejectConsent(state, client_id) {
      const storedConsent = state.relyingPartyConsent.find(relyingParty => relyingParty.client_id === client_id);
      storedConsent.accepted = false;
      storedConsent.rejected = true;
    },

    clearConsentStore(state) {
      state.consentInvoker = null;
      state.relyingPartyConsent = [];
    },

    setConsentInvoker(state, consentInvoker) {
      state.consentInvoker = consentInvoker;
    }
  },

  actions: {
    loadRelyingPartyProfile(context, client_id: string) {
      axios
        .get('api/profile?client_id=' + client_id)
        .then(response => {
          const profile = response.data;
          if (profile) {
            context.commit('addRelingPartyConsentInfo', profile);
            context.commit('setSecondFactorRequired', profile.f2_auth_req);
            context.commit('setOidcCompat', profile.oidc_compat);
          }
        })
        .catch(() => {
          console.log('Profile loading failed.');
        });
    },
    acceptRelyingPartyConsent(context, client_id: string) {
      axios
        .post('api/delegate/cocos/relying-party', { clientId: client_id })
        .then(response => {
          context.commit('acceptConsent', client_id);
        })
        .catch(() => {
          console.log('Consent saving failed.');
        });
    },
    rejectRelyingPartyConsent(context, client_id: string) {
      context.commit('rejectConsent', client_id);
    }
  }
};
